import { Suspense, lazy } from 'react';
import { Route } from 'react-router';
import { routePathsOrderPickup } from 'core/lib/routePaths/pickupsRoutePaths';
import { RouteLoader } from '#components/Loader/RouteLoader';

const OrderPickup = lazy(() => import('pickups/central-routes/pickups-routes'));

const PickupsRoute = lazy(() =>
  import('pickups/central-routes/pickups-routes').then((module) => ({
    default: module.PickupsRoute,
  })),
);

const PickupsConfirmationRoute = lazy(() =>
  import('pickups/central-routes/pickups-routes').then((module) => ({
    default: module.ConfirmationRoute,
  })),
);

const BatteryPickupRoute = lazy(() =>
  import('pickups/central-routes/pickups-routes').then((module) => ({
    default: module.BatteryPickupRoute,
  })),
);

const RequestBatteryPickupRoute = lazy(() =>
  import('pickups/central-routes/pickups-routes').then((module) => ({
    default: module.RequestBatteryPickupRoute,
  })),
);

const BatteryConfirmationRoute = lazy(() =>
  import('pickups/central-routes/pickups-routes').then((module) => ({
    default: module.BatteryConfirmationRoute,
  })),
);

const PreviousOrdersRoute = lazy(() =>
  import('pickups/central-routes/pickups-routes').then((module) => ({
    default: module.PreviousOrdersRoute,
  })),
);

const PickupScheduleRoute = lazy(() =>
  import('pickups/central-routes/pickups-routes').then((module) => ({
    default: module.PickupsScheduleRoute,
  })),
);

const DeclarationRoute = lazy(() =>
  import('pickups/central-routes/pickups-routes').then((module) => ({
    default: module.DeclarationRoute,
  })),
);

const RentedContainersRoute = lazy(() =>
  import('pickups/central-routes/pickups-routes').then((module) => ({
    default: module.RentedContainersRoute,
  })),
);

const SortingGuidanceRoute = lazy(() =>
  import('pickups/central-routes/pickups-routes').then((module) => ({
    default: module.SortingGuidanceRoute,
  })),
);

const AddContainersRoute = lazy(() =>
  import('pickups/central-routes/pickups-routes').then((module) => ({
    default: module.AddContainersRoute,
  })),
);

const AddContainersConfirmationPage = lazy(() =>
  import('pickups/central-routes/pickups-routes').then((module) => ({
    default: module.AddContainersConfirmationPageRoute,
  })),
);

export const PickupsRouteTree = (
  <Route
    path={routePathsOrderPickup.ORDER_PICKUP}
    element={
      <Suspense fallback={<RouteLoader />}>
        <OrderPickup />
      </Suspense>
    }
  >
    <Route index element={<PickupsRoute />} />
    <Route path={routePathsOrderPickup.CONFIRMATION}>
      <Route path=":confirmationId" element={<PickupsConfirmationRoute />} />
    </Route>
    <Route path={routePathsOrderPickup.LI_ION_BATTERIES}>
      <Route index element={<BatteryPickupRoute />} />
      <Route
        path={routePathsOrderPickup.LI_ION_BATTERIES_REQUEST_PICKUP}
        element={<RequestBatteryPickupRoute />}
      />
      <Route
        path={routePathsOrderPickup.LI_ION_BATTERIES_CONFIRMATION}
        element={<BatteryConfirmationRoute />}
      />
    </Route>
    <Route path={routePathsOrderPickup.PREVIOUS_ORDERS} element={<PreviousOrdersRoute />} />
    <Route path={routePathsOrderPickup.PICKUP_SCHEDULE} element={<PickupScheduleRoute />} />
    <Route path={routePathsOrderPickup.DECLARATION} element={<DeclarationRoute />} />
    <Route path={routePathsOrderPickup.SORTING_GUIDANCE} element={<SortingGuidanceRoute />} />
    <Route path={routePathsOrderPickup.RENTED_CONTAINERS}>
      <Route index element={<RentedContainersRoute />} />
      <Route path={routePathsOrderPickup.RENTED_CONTAINERS_ADD_CONTAINERS}>
        <Route index element={<AddContainersRoute />} />
        <Route
          path={routePathsOrderPickup.RENTED_CONTAINERS_ADD_CONTAINERS_CONFIRMATION}
          element={<AddContainersConfirmationPage />}
        />
      </Route>
    </Route>
  </Route>
);

export const preloadPickups = () => {
  //Import default export to trigger preload
  void import('pickups/central-routes/pickups-routes');
};
